import React, { useState } from "react";
import {
  dealerWorkshopIcon,
  customerWorkshopIcon,
  externalCompanyIcon,
} from "./MapsIcons";

const scaniaColor = dealerWorkshopIcon().fillColor ?? "#041E42";
const customerColor = customerWorkshopIcon().fillColor ?? "#ff6200ff";
const externalColor = externalCompanyIcon().fillColor ?? "#00811aff";

interface FiltersPanelProps {
  selectedTypes: string[];
  onChangeTypes: (types: string[]) => void;
  selectedServices: string[];
  onChangeServices: (services: string[]) => void;
  selectedSources: ("Scania" | "External" | "Customer")[];
  onChangeSources: (sources: ("Scania" | "External" | "Customer")[]) => void;
  showOnlyOpenNow: boolean;
  onToggleOpenNow: (show: boolean) => void;
  selectedFuels: string[];
  onChangeFuels: (fuels: string[]) => void;
}
const fuelFilters = [
  { code: "electric", label: "Electric", services: ["e-mobilityvcbbatteryrepairserviceworkshop", "e-mobilityvcbserviceworkshop"] },
  { code: "hybrid", label: "Hybrid", services: ["e-mobilityvcbbatteryrepairserviceworkshop", "e-mobilityvcbserviceworkshop"] },
  { code: "lng", label: "LNG", services: ["gasvehicleservicelng"] },
  { code: "cng", label: "CNG", services: ["gasvehicleservicecng"] },
];

const typeFilters = [
  { code: "truckservice", label: "Truck" },
  { code: "industrialpowergenerationenginesservice", label: "Industrial Engine" },
  { code: "busservice", label: "Bus" },
  { code: "trailerservice", label: "Trailer" },
  { code: "marineenginesservice", label: "Marine Engine" },
];

const serviceFilters = [
  { code: "24hassistance", label: "24/H" },
  { code: "tyreservice", label: "Tyre" },
  { code: "hookliftservice", label: "Hook lift" },
  { code: "tailliftservices", label: "Tail lift" },
  { code: "e-mobilityvcbbatteryrepairserviceworkshop", label: "E-mobility VCB Battery Repair Service Workshop" },
  { code: "e-mobilityvcbserviceworkshop", label: "E-mobility VCB Service Workshop" },
  { code: "hydraulicsbodyworkservice", label: "Hydraulics/Bodywork" },
  { code: "adrvehicleservice", label: "ADR" },
  { code: "tarpaulinservice", label: "Tarpaulin service" },
  { code: "transportrefrigerationunitservice", label: "Transport Refrigeration Unit" },
  { code: "WIP", label: "Towing & Recovery WIP" },
];

const sourceFilters = ["Scania", "External", "Customer"] as const;

const FiltersPanel: React.FC<FiltersPanelProps> = ({
  selectedTypes,
  onChangeTypes,
  selectedServices,
  onChangeServices,
  selectedSources,
  onChangeSources,
  showOnlyOpenNow,
  onToggleOpenNow,
  selectedFuels,
  onChangeFuels,
}) => {
  const [showTypeFilters, setShowTypeFilters] = useState(false);
  const [showServiceFilters, setShowServiceFilters] = useState(false);
  const [showSourceFilters, setShowSourceFilters] = useState(false);
  const [showFuelFilters, setShowFuelFilters] = useState(false);
  return (
    <div
      style={{
        background: "#ffffff",
        border: "1px solid #d9d9d9",
        borderRadius: "8px",
        padding: "0.85rem 1rem",
        marginBottom: "1rem",
        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        fontFamily: "Roboto, Arial, sans-serif",
      }}
    >
      <div style={{ marginBottom: "0.7rem" }}>
        <div
          onClick={() => setShowTypeFilters((prev) => !prev)}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            userSelect: "none",
            marginBottom: showTypeFilters ? "0.18rem" : 0,
          }}
        >
          <h4 style={{ fontSize: "14px", margin: 0, marginBottom: 0, color: "#002663", fontWeight: 700 }}>
            Filter by Type
          </h4>
          <span style={{ fontSize: "1.1rem", color: "#002663" }}>
            {showTypeFilters ? "▲" : "▼"}
          </span>
        </div>
        {showTypeFilters && (
          <div style={{ marginTop: "0.18rem" }}>
            {typeFilters.map(({ code, label }) => (
              <label key={code} style={{ display: "block", marginBottom: "0.15rem", fontWeight: 400, color: "#222" }}>
                <input
                  type="checkbox"
                  checked={selectedTypes.includes(code)}
                  onChange={(e) =>
                    onChangeTypes(
                      e.target.checked
                        ? [...selectedTypes, code]
                        : selectedTypes.filter((s) => s !== code)
                    )
                  }
                  style={{ marginRight: "0.45em", accentColor: "#002663" }}
                />
                {label}
              </label>
            ))}
          </div>
        )}
      </div>

      <div style={{ marginBottom: "0.7rem" }}>
        <div
          onClick={() => setShowServiceFilters((prev) => !prev)}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            userSelect: "none",
            marginBottom: showServiceFilters ? "0.18rem" : 0,
          }}
        >
          <h4 style={{ fontSize: "14px", margin: 0, marginBottom: 0, color: "#002663", fontWeight: 700 }}>
            Filter by Service
          </h4>
          <span style={{ fontSize: "1.1rem", color: "#002663" }}>
            {showServiceFilters ? "▲" : "▼"}
          </span>
        </div>
        {showServiceFilters && (
          <div style={{ marginTop: "0.18rem" }}>
            {serviceFilters.map(({ code, label }) => (
              <label key={code} style={{ display: "block", marginBottom: "0.15rem", fontWeight: 400, color: "#222" }}>
                <input
                  type="checkbox"
                  checked={selectedServices.includes(code)}
                  onChange={(e) =>
                    onChangeServices(
                      e.target.checked
                        ? [...selectedServices, code]
                        : selectedServices.filter((s) => s !== code)
                    )
                  }
                  style={{ marginRight: "0.45em", accentColor: "#002663" }}
                />
                {label}
              </label>
            ))}
          </div>
        )}
      </div>

      <div style={{ marginBottom: "0.7rem" }}>
      <div style={{ marginBottom: "0.7rem" }}>
        <div
          onClick={() => setShowFuelFilters((prev) => !prev)}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            userSelect: "none",
            marginBottom: showFuelFilters ? "0.18rem" : 0,
          }}
        >
          <h4 style={{ fontSize: "14px", margin: 0, marginBottom: 0, color: "#002663", fontWeight: 700 }}>
            Filter by Fuel
          </h4>
          <span style={{ fontSize: "1.1rem", color: "#002663" }}>
            {showFuelFilters ? "▲" : "▼"}
          </span>
        </div>
        {showFuelFilters && (
          <div style={{ marginTop: "0.18rem" }}>
            {fuelFilters.map((filter) => (
              <label key={filter.code} style={{ display: "block", marginBottom: "0.15rem", fontWeight: 400, color: "#222" }}>
                <input
                  type="checkbox"
                  checked={selectedFuels.includes(filter.code)}
                  onChange={(e) =>
                    onChangeFuels(
                      e.target.checked
                        ? [...selectedFuels, filter.code]
                        : selectedFuels.filter((s) => s !== filter.code)
                    )
                  }
                  style={{ marginRight: "0.45em", accentColor: "#002663" }}
                />
                {filter.label}
              </label>
            ))}
          </div>
        )}
      </div>
        <div
          onClick={() => setShowSourceFilters((prev) => !prev)}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            userSelect: "none",
            marginBottom: showSourceFilters ? "0.18rem" : 0,
          }}
        >
          <h4 style={{ fontSize: "14px", margin: 0, marginBottom: 0, color: "#002663", fontWeight: 700 }}>
            Filter by Workshop Type
          </h4>
          <span style={{ fontSize: "1.1rem", color: "#002663" }}>
            {showSourceFilters ? "▲" : "▼"}
          </span>
        </div>
        {showSourceFilters && (
          <div style={{ marginTop: "0.18rem" }}>
            {sourceFilters.map((source) => (
              <label key={source} style={{ display: "block", marginBottom: "0.15rem", fontWeight: 400, color: "#222" }}>
                <input
                  type="checkbox"
                  checked={selectedSources.includes(source)}
                  onChange={(e) =>
                    onChangeSources(
                      e.target.checked
                        ? [...selectedSources, source]
                        : selectedSources.filter((s) => s !== source)
                    )
                  }
                  style={{ marginRight: "0.45em", accentColor: "#002663" }}
                />
                <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "12px",
                      height: "12px",
                      borderRadius: "2px",
                      backgroundColor:
                        source === "Scania"
                          ? scaniaColor
                          : source === "External"
                          ? externalColor
                          : source === "Customer"
                          ? customerColor
                          : "#ccc",
                    }}
                  />
                  {source}
                </span>
              </label>
            ))}
          </div>
        )}
      </div>

      <div>
        <label style={{ fontWeight: 400, color: "#222" }}>
          <input
            type="checkbox"
            checked={showOnlyOpenNow}
            onChange={(e) => onToggleOpenNow(e.target.checked)}
            style={{ marginRight: "0.45em", accentColor: "#002663" }}
          />
          Show only open workshops now
        </label>
      </div>
    </div>
  );
};

export default FiltersPanel;
